// extracted by mini-css-extract-plugin
export default {"memberTile":"UserCard_memberTile__V08xJ","body":"UserCard_body__FEdCO"};